import { render } from "./StockMain.vue?vue&type=template&id=1a40fa48&scoped=true"
import script from "./StockMain.vue?vue&type=script&lang=js"
export * from "./StockMain.vue?vue&type=script&lang=js"

import "./StockMain.vue?vue&type=style&index=0&id=1a40fa48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40fa48"]])

export default __exports__